/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-board-referral.reducer';

export const TumorBoardReferralDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorBoardReferralEntity = useAppSelector(state => state.tumorBoardReferral.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorBoardReferralDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.detail.title">TumorBoardReferral</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorBoardReferralEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardReferralEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardReferralEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardReferralEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardReferralEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tumorBoardReferralEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.referral">Referral</Translate>
          </dt>
          <dd>{tumorBoardReferralEntity.referral ? tumorBoardReferralEntity.referral.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.patient">Patient</Translate>
          </dt>
          <dd>{tumorBoardReferralEntity.patient ? tumorBoardReferralEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorBoardReferral.occurrence">Occurrence</Translate>
          </dt>
          <dd>{tumorBoardReferralEntity.occurrence ? tumorBoardReferralEntity.occurrence.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-board-referral" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-board-referral/${tumorBoardReferralEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorBoardReferralDetail;
